import { Component, OnInit, ChangeDetectionStrategy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from 'src/app/layout/pages/page/page.component';
import { PageListComponent } from 'src/app/layout/pages/page-list/page-list.component';
import { Reportnet3 } from '../models/reportnet3';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Reportnet3ListaService } from '../reportnet3-lista.service';
import { TRASMISSIONE_REPORTNET_COLUMNS, TRASMISSIONEREPORTNET_VISIBLECOLUMNS } from '../trasmissione-reportnet.config';
import { TrasmissioneReportNetService } from '../trasmissione-reportnet.service';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MyDialogComponent } from '../components/my-dialog/my-dialog.component';

@Component({
  selector: 'app-lista-page',
  standalone: true,
  imports: [
    PageComponent,
    CommonModule,
    PageListComponent,
    ReactiveFormsModule,
    MyButtonComponent,
    MatDialogModule,
    MyDialogComponent
  ],
  templateUrl: './lista-page.component.html',
  styleUrl: './lista-page.component.css'
})
export class ListaPageComponent implements OnInit {
  columns = TRASMISSIONE_REPORTNET_COLUMNS;
  visibleColumns = signal(TRASMISSIONEREPORTNET_VISIBLECOLUMNS);
  insertForm: FormGroup;
  filterForm: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    private trasmissioneReportNetService: TrasmissioneReportNetService,
    public reportnet3Service: Reportnet3ListaService,
    public dialog: MatDialog
  ) {
    this.insertForm = this.fb.group<Reportnet3>(<Reportnet3>{});
    this.filterForm = this.fb.group({
    search: this.fb.control('', []),
    filters: this.fb.group({})
  });}

  ngOnInit(): void {
    this.reportnet3Service.get()
    .subscribe((data) => {
      console.log(data);
    })
  }

  showDialog(): void {
    const dialogRef = this.dialog.open(MyDialogComponent, {
      width: '400px',
      height: '230px'
    })

    dialogRef.afterClosed().subscribe(() => {

    })
  }
}